module.exports = __webpack_public_path__ + "img/logo-white-en.b57db478.svg";